export const PICTURE_TYPE = {
  default: 0,
  idCardFront: 1,
  idCardBack: 2,
  idCardOnHand: 3,
  license: 4,
};

// 对应 COS_TYPE 为 common 的枚举值
export const COMMON_PICTURE_TYPE = {
  default: 5,
};

// 获取上传图片 url 的 cos 桶的类型，因为现在后台有两个上传图片的服务：1. 私有写私有读 2. 私有写公有读
export const COS_TYPE = {
  common: 'common', // 私有写公有读
  private: 'private', // 私有写私有读
};

// 如果是使用中台的加密 cos 桶上传的图片，需要传入 need_sign = 2 以便添加签名，如果不是，需要上有传入可下载的图片链接，并填写 need_sign = 1
export const COS_NEED_SIGN = {
  unnecessary: 1,
  need: 2,
};

export const REGISTER_TYPE = {
  talent: 'talent',
  company: 'company',
  inviteCode: 'inviteCode',
};
